import React from 'react';

import Issue from './Issue';

const Overtime = ({ issue }) => <Issue issue={issue} />;

export default Overtime;
